export default __webpack_public_path__ + "static/media/540.30a2fef4.gif";